import { AfterViewInit, Component, ElementRef, OnDestroy, Renderer2, ViewChild } from "@angular/core";
import { MatSidenav } from "@angular/material/sidenav";
import "leaflet";
// import 'leaflet-easybutton/src/easy-button';
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { Asset } from "src/app/classes/asset";
import { Events } from "src/app/classes/events";
import { MapSettings } from "src/app/classes/map-settings";
import { VanEventAddEvent } from "src/app/classes/vanEvent-addEvent";
import { WorkSpacePanels } from "src/app/classes/workspace-pannels";
import { CREW_VANS_TEXT, MAP_CENTER, MAP_ZOOM_INIT, MAP_ZOOM_NORMAL, OUTBOUND_MARKERS_TEXT, PARKING_TEXT, UNASSIGNED_TASK_MARKERS_TEXT } from "src/app/common/constants";
import { AssetService } from "src/app/services/asset.service";
import { EventsDeltaService } from "src/app/services/events-delta.service";
import { EventsService } from "src/app/services/events.service";
import { LoggerService } from "src/app/services/logger.service";
import { ManageVansService } from "src/app/services/manage-vans.service";
import { MapIconService } from "src/app/services/map-icon.service";
import { MapLayerService } from "src/app/services/map-layer.service";
import { MapSettingsService } from "src/app/services/map-settings.service";
import { NavService } from "src/app/services/nav.service";
import { OutboundAircraftMarkersService } from "src/app/services/outbound-aircraft-markers.service";
import { SideNavService } from "src/app/services/side-nav.service";
import { TaskMarkersService } from "src/app/services/task-markers.service";
import { environment } from "src/environments/environment";
import { MapMarkerService } from "../../services/map-marker.service";
import { MapShapeService } from "../../services/map-shape.service";

declare let L;
// import * as L from "leaflet";

@Component({
  standalone: false,
  selector: "app-map",
  templateUrl: "./map.component.html",
  styleUrls: ["./map.component.scss"],
})
export class MapComponent implements AfterViewInit, OnDestroy {

  map: L.Map;
  @ViewChild('map', { static: false }) mapElement: ElementRef;
  mapClass = '';
  private layersControl = L.control.layers();
  panelTitle = '';
  vanMarkersLayerGroup: L.LayerGroup;
  locMarkersLayerGroup;
  outboundAircraftMarkersLayerGroup;
  taskMarkersLayerGroup;
  unassignedTaskMarkersLayerGroup;
  parkingOverlayLayerGroup;
  allOverlays = {};
  unsubscribe$: Subject<boolean> = new Subject();
  @ViewChild('drawer', {static:false}) public drawer: MatSidenav;
  @ViewChild('drawer1', {static:false}) public drawer1: MatSidenav;
  panels: WorkSpacePanels = new WorkSpacePanels();
  useThisBaseMapLayer: any;
  eventData: Events;
  assetData: Array<Asset>;
  mapSettings: MapSettings;
  mapShortcutBarEvenRamps: L.Control.EasyBar;
  mapShortcutBarOddRamps: L.Control.EasyBar;
  mapShortcutBarPOI: L.Control.EasyBar;
  mapShortcutBarWings: L.Control.EasyBar;
  mapLegend: L.Control;

  constructor(
    private mapMarkerService: MapMarkerService,
    private mapShapeService: MapShapeService,
    private mapLayerService: MapLayerService,
    private mapIconService: MapIconService,
    private assetService: AssetService,
    private logger: LoggerService,
    private navService: NavService,
    private sideNavService: SideNavService,
    private renderer: Renderer2,
    private eventsService: EventsService,
    private deltaService: EventsDeltaService,
    private outboundAircraftMarkersService: OutboundAircraftMarkersService,
    private taskMarkersService: TaskMarkersService,
    private mapSettingsService: MapSettingsService,
    private manageVansService: ManageVansService
  ) {
    this.subscribeToEventData();
    this.subscribeToAssetData();
    this.subscribeToDeltaData();
    this.subscribeToManageVans();
    this.subscribeToPanelChange();
  }

  mergeAssetLocationIntoEventData(assetData: any): void{
    if(this.eventData){
      let addEvents: Array<VanEventAddEvent> = this.eventData.vanEvents.addEvents;
      let newAddEventsArray = [];
      addEvents.forEach((event: VanEventAddEvent) => {
        assetData.forEach((asset: Asset) => {
          if(event.vanName === asset.name){
            event.latitude = asset.position.latitude;
            event.longitude = asset.position.longitude;
            newAddEventsArray.push(event);
          }
        });
      });
      this.eventData.vanEvents.addEvents = newAddEventsArray;
      this.makeDynamicOverlays(this.eventData);
    }
  }

  private subscribeToAssetData(): void{
    this.assetService.getAssetData()
    .pipe(
      takeUntil(this.unsubscribe$))
        .subscribe(assetData => {
         this.mergeAssetLocationIntoEventData(assetData)
        }
    );
  }

  private subscribeToEventData(): void{
    this.eventsService.getEventData()
    .pipe(
      takeUntil(this.unsubscribe$))
        .subscribe(eventData => {
          if(eventData){
            this.eventData = eventData;
            this.makeDynamicOverlays(this.eventData);
          }
        }
    );
  }

  private subscribeToDeltaData(){
    this.deltaService.getEventData()
    .pipe(
      takeUntil(this.unsubscribe$))
        .subscribe(eventData => {
          if(eventData){
            this.eventData = eventData;
          }
        }
    );
  }

  private subscribeToManageVans(){
    this.manageVansService.zoomLocation$.pipe(takeUntil(this.unsubscribe$)).subscribe((pos: L.LatLng) => {
      this.zoomToVan(pos);
    });
  }

  private getMapPref(worldport,worldportDay,worldportNight,dark,satalite,bing): L.TileLayer | L.ImageOverlay{
    if (localStorage.prefMapBaseLayer == null || typeof localStorage.prefMapBaseLayer == "undefined") {
      localStorage.prefMapBaseLayer = "parkingNight"; //set default if first time
    }
    const userPrefLayer = localStorage.prefMapBaseLayer;
    switch (userPrefLayer) {
      case "parkingDay":
      case "parkingDayMap":
        this.renderer.addClass(this.mapElement.nativeElement, 'parkingDay');
        return worldportDay;
      case "parkingNight":
      case "parkingNightMap":
        this.renderer.addClass(this.mapElement.nativeElement, 'parkingNight');
        return worldportNight;
      case "Worldport":
        return worldport;
      case "Dark":
        return dark;
      case "Satalite":
        return satalite;
      case "Bing":
        return bing;
      default:
        return null;
     }
  }


  private initMap(): void {

    this.logger.debug("initMap called", 'ui');

    this.mapSettingsService.mapSettings$.pipe(takeUntil(this.unsubscribe$)).subscribe((mapSettings: MapSettings) => {
      this.mapSettings = mapSettings;
      if(this.map){
        this.setMapSettings(this.mapSettings);
      }
    });

    this.mapLayerService._activeLayer.pipe(takeUntil(this.unsubscribe$)).subscribe((data: string) => {
      this.changeLayer(data);
    });

    // this.subscribeToEventData();
    // this.subscribeToAssetData();
    // this.subscribeToDeltaData();
    // this.subscribeToManageVans();

    L.Marker.prototype.options.icon = this.mapIconService.setDefaultIconOptions();
    const worldport = this.mapLayerService.makeWorldportBaseMap();
    const worldportDay = this.mapLayerService.makeWorldportDayMap();
    const worldportNight = this.mapLayerService.makeWorldportNightMap();
    const dark = this.mapLayerService.makeDarkBaseMap();
    const satalite = this.mapLayerService.makeSatelliteBaseMap();
    const bing = this.mapLayerService.makeBingBaseMap();
    // this.layersControl.addBaseLayer(worldport, LIGHT_MAP_NAME);
    this.layersControl.addBaseLayer(worldportDay, "Worldport Day");
    this.layersControl.addBaseLayer(worldportNight, "Worldport Night");
    // this.layersControl.addBaseLayer(dark, DARK_MAP_NAME);
    // this.layersControl.addBaseLayer(satalite, "Satalite");
    this.layersControl.addBaseLayer(bing, "Bing");

    this.map = L.map("map", {
      center: MAP_CENTER,
      layers: this.getMapPref(worldport,worldportDay,worldportNight,dark,satalite,bing),
      inertia: true,
      fadeAnimation: false,
      zoom: MAP_ZOOM_INIT,
      // zoomDelta: 0.5,
      zoomAnimation: true,
      zoomAnimationThreshold: 18,
      zoomControl: true,
      markerZoomAnimation: false,
      maxzoom: 18,
      minzoom: 15
    });

    this.map.whenReady(() => {
      this.setMapSettings(this.mapSettings);
      L.control.scale({metric:false,position:'bottomright'}).addTo(this.map);
      this.layersControl.addTo(this.map);
     // this.addStaticOverlaysToControl();
      this.map.flyTo(new L.LatLng(38.16773079799735,-85.73181152343751), MAP_ZOOM_NORMAL);
    });


    this.map.on('zoomend', (e: any) => {
      this.logger.debug('ZOOM LEVEL: ', e.target._zoom, 'ui');
    });

    this.map.on('click', (e: any) => {
      this.logger.info(`MAP CLICK: ${this.makeLatLngObj(e.latlng)}`);
    });

    this.map.on('baselayerchange', (e: any) => {
      const layerName = e.name;
      const currentMapClasses = this.mapElement.nativeElement.classList;
      currentMapClasses.forEach(className => {
        if(className === 'parkingDay' || className === 'parkingNight'){
          this.renderer.removeClass(this.mapElement.nativeElement, className);
        }
      });
      switch (layerName) {
        case "Worldport Day":
          this.renderer.addClass(this.mapElement.nativeElement, 'parkingDay');
          localStorage.prefMapBaseLayer = "parkingDay";
          break;
        case "Worldport Night":
          this.renderer.addClass(this.mapElement.nativeElement, 'parkingNight');
          localStorage.prefMapBaseLayer = "parkingNight";
          break;
        case "Worldport":
          localStorage.prefMapBaseLayer = "Worldport";
          break;
        case "Dark":
          localStorage.prefMapBaseLayer = "Dark";
          break;
        case "Satalite":
          localStorage.prefMapBaseLayer = "Satalite";
          break;
        case "Bing":
          localStorage.prefMapBaseLayer = "parkingNight";
          break;
        default:
          break;
      }

    });
  }


  setMapSettings(mapSettings: MapSettings): void{
    this.removeMapControls();
    if(mapSettings.displayPOIChecked){
      this.mapShortcutBarPOI = this.mapSettingsService.makeShortcutBars('others').addTo(this.map);
    }
    if(mapSettings.displayOddRampsChecked){
      this.mapShortcutBarOddRamps = this.mapSettingsService.makeShortcutBars('oddramps').addTo(this.map);
    }
    if(mapSettings.displayEvenRampsChecked){
      this.mapShortcutBarEvenRamps = this.mapSettingsService.makeShortcutBars('evenramps').addTo(this.map);
    }
    if(mapSettings.displayWingsChecked){
     this.mapShortcutBarWings = this.mapSettingsService.makeShortcutBars('wings').addTo(this.map);
    }
    if(mapSettings.displayLegendChecked){
      this.mapLegend = this.mapSettingsService.makeMapLegend().addTo(this.map);
    }
  }

  removeMapControls(): void{
    if(this.map){
      try{this.map.removeControl(this.mapShortcutBarPOI)}
        catch(e){}
      try{this.map.removeControl(this.mapShortcutBarOddRamps)}
        catch(e){}
      try{this.map.removeControl(this.mapShortcutBarEvenRamps)}
        catch(e){}
      try{this.map.removeControl(this.mapShortcutBarWings)}
        catch(e){}
      try{this.map.removeControl(this.mapLegend)}
        catch(e){}
    }
  }

  makeLatLngObj(latlng: L.LatLng): string{
    return `${latlng.lat},${latlng.lng}`;
  }

  onLocationFound(e): void {
    const radius = e.accuracy;
    const marker = L.marker(e.latlng, { title: "test" }).bindPopup(
      "You are within " + radius + " meters from this point"
    );
    marker.addTo(this);
    //.openPopup();
    const circle = L.circle(e.latlng, radius);
    circle.addTo(this);
  }

  onLocationError(e): void {
    this.logger.error(e.message);
  }

  stopLocate(): void {
    this.map.stopLocate();
  }

  private makeDynamicOverlays(data:Events) {
    if (data) {
      // this.capitalMarkersLayerGroup = this.mapMarkerService.makeCapitalMarkers();
      // this.capitalCircleMarkersLayerGroup = this.mapMarkerService.makeCapitalCircleMarkers();
      // this.statesOverlayLayerGroup = this.mapShapeService.makeStatesOverlay();
      // this.locMarkersLayerGroup = this.mapMarkerService.makeLocationAccuracyMarkers(data);
      this.vanMarkersLayerGroup = this.mapMarkerService.processVanMarkers( data, environment.animateVanMarkers );
      this.outboundAircraftMarkersLayerGroup = this.outboundAircraftMarkersService.processOutboundMarkers( data );
      if(data.unassignedTaskStatus !== 'noChange'){
        this.unassignedTaskMarkersLayerGroup = this.taskMarkersService.processUnassignedTaskMarkers( data );
      }
      if(data.driverTaskStatus !== 'noChange'){
        this.taskMarkersLayerGroup = this.taskMarkersService.processTaskMarkers( data );
      }
      this.addDynamicOverlaysToControl();
    }else{
      console.log("NO DATA")
    }
  }

  private addStaticOverlaysToControl() {
    // these do not have a remote http data dependency so only create the overlay once
    this.parkingOverlayLayerGroup = this.mapShapeService.makeRampsOverlay();
    this.allOverlays[PARKING_TEXT] = this.parkingOverlayLayerGroup;
    this.layersControl.addOverlay(this.parkingOverlayLayerGroup, PARKING_TEXT);
  }

  private addDynamicOverlaysToControl(): void {
    this.layersControl._layers.forEach(() => {
      if (!this.allOverlays[CREW_VANS_TEXT]) {
        this.allOverlays[CREW_VANS_TEXT] = this.vanMarkersLayerGroup;
        this.map.addLayer(this.vanMarkersLayerGroup); // adding van layer on map init
        this.layersControl.addOverlay( this.vanMarkersLayerGroup, CREW_VANS_TEXT );
      }
      if (!this.allOverlays[OUTBOUND_MARKERS_TEXT]) {
        this.allOverlays[OUTBOUND_MARKERS_TEXT] = this.outboundAircraftMarkersLayerGroup;
        this.map.addLayer(this.outboundAircraftMarkersLayerGroup); // adding outbound aircraft layer on map init
        this.layersControl.addOverlay(this.outboundAircraftMarkersLayerGroup,OUTBOUND_MARKERS_TEXT);
      }
      if (!this.allOverlays[UNASSIGNED_TASK_MARKERS_TEXT]) {
        this.allOverlays[UNASSIGNED_TASK_MARKERS_TEXT] = this.unassignedTaskMarkersLayerGroup;
        this.map.addLayer(this.unassignedTaskMarkersLayerGroup);
        this.layersControl.addOverlay(this.unassignedTaskMarkersLayerGroup,UNASSIGNED_TASK_MARKERS_TEXT);
      }
      //if (!this.allOverlays[LOC_ACCURACY_TEXT]) {
      // this.allOverlays[LOC_ACCURACY_TEXT] = this.locMarkersLayerGroup;
      // this.layersControl.addOverlay(this.locMarkersLayerGroup,LOC_ACCURACY_TEXT);
      //}
      //if (!this.allOverlays[CAPITAL_MARKERS_TEXT]) {
      // this.allOverlays[CAPITAL_MARKERS_TEXT] = this.capitalMarkersLayerGroup;
      // this.layersControl.addOverlay(this.capitalMarkersLayerGroup,CAPITAL_MARKERS_TEXT);
      //}
      //if (!this.allOverlays[CAPITAL_CIRCLE_MARKERS_TEXT]) {
      // this.allOverlays[CAPITAL_CIRCLE_MARKERS_TEXT] = this.capitalCircleMarkersLayerGroup;
      // this.layersControl.addOverlay(this.capitalCircleMarkersLayerGroup,CAPITAL_CIRCLE_MARKERS_TEXT);
      //}
      //if (!this.allOverlays[STATES_OVERLAY_TEXT]) {
      // this.allOverlays[STATES_OVERLAY_TEXT] = this.statesOverlayLayerGroup;
      // this.layersControl.addOverlay(this.statesOverlayLayerGroup,STATES_OVERLAY_TEXT);
      //}
      this.taskMarkersLayerGroup.addTo(this.map);
    });
  }

  private changeLayer(layer: string): void {
    this.layersControl._layers.forEach((item) => {
      if (item.name == layer) {
        this.map.addLayer(item.layer);
      } else {
        if (item.name !== CREW_VANS_TEXT && item.name !== PARKING_TEXT
          && item.name !== OUTBOUND_MARKERS_TEXT && item.name !== UNASSIGNED_TASK_MARKERS_TEXT) {
          this.map.removeLayer(item.layer);
        }
      }
    });
  }

  zoomLevelChanged(e): void {
    this.logger.debug(`ZOOM LEVEL: ${e.target._zoom}`, 'ui');
  }

  markerOnClick(e): void {
    if(e && e.latlng && e.latlng.toString().length > 0 && e !== undefined && e != null){
      const x = e.latlng.toString();
      this.logger.debug(`LATLNG: ` + x, 'ui');
    }
  }

  ngAfterViewInit(): void {
    this.initMap();
    this.subscribeToDrawers();

    //   this.map.setView(MAP_CENTER);
    //   L.Control.Watermark = L.Control.extend({
    //     onAdd: function(map) {
    //         var img = L.DomUtil.create('img');

    //         img.src = '/assets/images/outline_north_black_24dp.png';
    //         img.style.width = '200px';

    //         return img;
    //     },

    //     onRemove: function(map) {
    //         // Nothing to do here
    //     }
    // });

    // L.control.watermark = function(opts) {
    //     return new L.Control.Watermark(opts);
    // }

    // L.control.watermark({ position: 'bottomleft' })
    // .addTo(this.map);


  }

  changePanel(panel: string): void{
    this.navService.setPanelObs(panel);
  }


  subscribeToPanelChange(): void{
    this.navService.getPanelObs().pipe(takeUntil(this.unsubscribe$)).subscribe((panel) => {
      this.setPanel(panel);
    });
  }

  subscribeToDrawers(): void{
    this.navService.getDrawerObs()
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((drawer) => {
          if (drawer) {
            if(drawer === 'drawer'){
               this.drawer.toggle()
            }
            if(drawer === 'drawer1'){
              this.drawer1.toggle()
            }
          }
      });
  }

  // This is fired from an emitter in the vertival-menu component.
  // This iterates through this.panels object to find a matching key from the string that was passed
  // in from the vertical-menu component. Then sets it to true while setting all others to false.
  public setPanel(panel: string): void{
    Object.keys(this.panels).forEach(item => {
      if(panel === item){
        this.panels[item] = true;
        this.panelTitle = this.sideNavService.makePanelTitle(panel);
      }else{
        this.panels[item] = false;
      }
    });
  }

  zoomToVan(pos: L.LatLng){
    this.map.flyTo(pos, 17);
  }

  openMyTasks(event: any){
    // console.log(event);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
  }


}

